module.exports = __webpack_public_path__ + "media/images/tiedye/sherbet-18000-547e300037fa5843bec46097f2723521.jpg";